import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../Services/api.service';
import { CommonModule } from '@angular/common';
import { CategoryAccordionComponent } from "./category-accordion/category-accordion.component";
import { NzIconModule } from 'ng-zorro-antd/icon';
import { UpdateAttributesComponent } from "./update-attributes/update-attributes.component";
import { EdpAdrMappingComponent } from "./edp-adr-mapping/edp-adr-mapping.component";
import { ActivatedRoute } from '@angular/router';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { RouterModule } from '@angular/router';
import { UserAssociationComponent } from './user-association/user-association.component';
import { FilterCriteriaComponent } from "./filter-criteria/filter-criteria.component";
import { LotSizeCrtiteriaComponent } from './lot-size-crtiteria/lot-size-crtiteria.component';

@Component({
  selector: 'app-catalog-manage',
  standalone: true,
  imports: [CommonModule, CategoryAccordionComponent, NzIconModule, UpdateAttributesComponent,
    EdpAdrMappingComponent, UserAssociationComponent, RouterModule, FilterCriteriaComponent,LotSizeCrtiteriaComponent],
  templateUrl: './catalog-manage.component.html',
  styleUrl: './catalog-manage.component.scss'
})
export class CatalogManageComponent implements OnInit {

  catalogId: any = '';
  catalogOptions = [{
    id: 1, name: "Add/Edit Catalog", clicked: true
  }, 
  {
    id: 2, name: "Attributes", clicked: false
  },
  {
    id: 3, name: "EDP/AR Mapping", clicked: false
  },
  {
    id: 4, name: "User Association", clicked: false
  },
  {
    id: 5, name: "Lot - Sizes Filtration", clicked: false
  },
 {
    id: 6, name: "Filter Criteria", clicked: false
  }];

  activeTab:string="";
  constructor(public apiService: ApiService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.handleTab(this.catalogOptions[0]);
    this.catalogId = this.route.snapshot.paramMap.get('id');
  }

  handleTab(tab: any) {
    this.catalogOptions.map(node => {
      if (node.id == tab.id) {
        node.clicked = true;
        this.activeTab = node.name;
      }
      else {
        node.clicked = false;
      }
    })
  }

}
